import React, { Component, useState } from 'react';
import Header from "./dashboard/header";
import Visualization from './dashboard/visualization';
import * as d3 from 'd3';

function Dashboard(){
    const [data,setData] = React.useState([]);
    const [pos,setPos] = React.useState([]);
    const [chr,setChr] = React.useState([]);
    const [refV,setRefV] = React.useState([]);
    const [altV,setAltV] = React.useState([]);
    const [codV,setCodV] = React.useState([]);
    const [AF,setAF] = React.useState([]);
    const [dna,setDna] = React.useState([]);
    const [biobanks,setBiobanks] = React.useState([]);
    const [betas,setBetas] = React.useState([]);
    const [PIPs,setPIPs] = React.useState([])
    const [AFs,setAFs] = React.useState([]);
    const [topLoci,setTopLoci] = React.useState([]);
    const [extra,setExtra] = React.useState({af: false, pip: false});
    const [ranges, setRanges] = React.useState([]);
    const [types, setTypes] = React.useState([])

    function handleDataChange (data,biobanks,betas,PIPs,AFs,types,ranges,chr,pos,refV,altV,AF,dna,codV,topLoci) {
        setRanges(ranges);
        setTypes(types)
        setData(data);
        setBiobanks(biobanks);
        setBetas(betas);
        setPIPs(PIPs)
        setAFs(AFs)
        setPos(pos);
        setChr(chr);
        setRefV(refV);
        setAltV(altV);
        setAF(AF);
        setDna(dna);
        setCodV(codV);
        setTopLoci(topLoci); 
    }

    function format (type, datum) {

        if (datum === undefined || datum === null || Number.isNaN(datum) || datum === 'NA') return '–'
        else if (datum === 0) return '0'
        else if (datum === 1) return '1'
        else if (type === 'bb') {
            let b = datum.replace(/_|#|-|\./g, " ").replace("pval", " ").trim()
            let c = b.charAt(0).toUpperCase() + b.slice(1)
            return c
        }
        else if (type === 'bbshort') {
            let b = datum.replace(/_|#|-|\./g, " ").replace("pval", " ").trim()
            let c = b.charAt(0).toUpperCase() + b.slice(1)
            if (c.length > 13) return c.slice(0, 11).trim() + '...'
            return c
        }
        else if (type === 'gn') {
            if (datum.length === 0) return '–'
            else {
                let b = JSON.stringify(datum)
                let c = b.replace(/"|\[|\]/g, "").replace(/\,/g, ", ")
                return c
            }
        }
        else if (type === 'cd') {
            let b = datum.replace(/_|#|-|\./g, " ").replace("pval", " ").trim()
            let c = b.charAt(0).toUpperCase() + b.slice(1)
            return c
        }
        else if (type === 'ky') {
            let b = datum.replace(/_|#\./g, " ").replace(/#/g, "")
            let c = b.charAt(0).toUpperCase() + b.slice(1)
            return c
        }
        else if (type === 'pv') return d3.format(".1e")(datum)
        else if (type === 'bt') return d3.format("+.2f")(datum)
        else if (type === 'af') return d3.format(".1e")(datum)
        else if (type === 'pp') return d3.format(".3f")(datum)
    }

    function getExtra (both, one, none) {
        if (extra.af === true && extra.pip === true) return both
        else if (extra.af === true || extra.pip === true) return one
        else return none
    }

    return(
        <>
            <Header 
                data={data}
                handleDataChange={handleDataChange}
                extra={extra}
                setExtra={setExtra}
                getExtra={getExtra}
                setData={setData}
                format={format}
                />
            {codV.length > 0 && (
                <Visualization
                    data={data} 
                    biobanks={biobanks} 
                    betas={betas} 
                    types={types}
                    PIPs={PIPs}
                    AFs={AFs}
                    pos={pos}
                    chr={chr}
                    refV={refV}
                    altV={altV}
                    codV={codV}
                    AF={AF}
                    dna={dna}
                    extra={extra}
                    getExtra={getExtra}
                    topLoci={topLoci}
                    format={format}
                    ranges={ranges}
                    setRanges={setRanges}
                    />
            )}
        </>
    );
}
export default Dashboard;